module.exports = __webpack_public_path__ + "img/3.93822abb.png";